export default "__VITE_ASSET__BgFn5yvH__"